module.exports = __webpack_public_path__ + "static/media/clippy.081a7fc5.gif";